import { getPaginationFromMeta } from '../utils/commonFunctions';

export const GET_PIP_EPOS_SUBMISSION_LIST_PENDING = 'GET_PIP_EPOS_SUBMISSION_LIST_PENDING';
export const GET_PIP_EPOS_SUBMISSION_LIST_FULFILLED = 'GET_PIP_EPOS_SUBMISSION_LIST_FULFILLED';
export const GET_PIP_EPOS_SUBMISSION_LIST_REJECTED = 'GET_PIP_EPOS_SUBMISSION_LIST_REJECTED';
export const GET_PIP_EPOS_SUBMISSION_PENDING = 'GET_PIP_EPOS_SUBMISSION_PENDING';
export const GET_PIP_EPOS_SUBMISSION_FULFILLED = 'GET_PIP_EPOS_SUBMISSION_FULFILLED';
export const GET_PIP_EPOS_SUBMISSION_REJECTED = 'GET_PIP_EPOS_SUBMISSION_REJECTED';
export const PATCH_VALIDATE_PIP_EPOS_SUBMISSION_PENDING = 'PATCH_VALIDATE_PIP_EPOS_SUBMISSION_PENDING';
export const PATCH_VALIDATE_PIP_EPOS_SUBMISSION_FULFILLED = 'PATCH_VALIDATE_PIP_EPOS_SUBMISSION_FULFILLED';
export const PATCH_VALIDATE_PIP_EPOS_SUBMISSION_REJECTED = 'PATCH_VALIDATE_PIP_EPOS_SUBMISSION_REJECTED';
export const PATCH_DECLINE_PIP_EPOS_SUBMISSION_PENDING = 'PATCH_DECLINE_PIP_EPOS_SUBMISSION_PENDING';
export const PATCH_DECLINE_PIP_EPOS_SUBMISSION_FULFILLED = 'PATCH_DECLINE_PIP_EPOS_SUBMISSION_FULFILLED';
export const PATCH_DECLINE_PIP_EPOS_SUBMISSION_REJECTED = 'PATCH_DECLINE_PIP_EPOS_SUBMISSION_REJECTED';

const initialState = {
  pipEposSubmission: {},
  pipEposSubmissions: [],
  meta: {},
  fetching: false,
  fetched: false,
  errors: {},
  paging: {
    number: 1,
    size: 20
  }
};

export default function pipEposSubmissionsReducer(state = initialState, action) {
  switch (action.type) {
    case PATCH_VALIDATE_PIP_EPOS_SUBMISSION_PENDING:
    case PATCH_DECLINE_PIP_EPOS_SUBMISSION_PENDING:
    case GET_PIP_EPOS_SUBMISSION_PENDING:
    case GET_PIP_EPOS_SUBMISSION_LIST_PENDING: {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case PATCH_VALIDATE_PIP_EPOS_SUBMISSION_FULFILLED:
    case PATCH_DECLINE_PIP_EPOS_SUBMISSION_FULFILLED:
    case GET_PIP_EPOS_SUBMISSION_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pipEposSubmission: action.payload.data
      };
    }
    case GET_PIP_EPOS_SUBMISSION_LIST_FULFILLED: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pipEposSubmissions: action.payload.data,
        meta: action.payload.meta,
        paging: getPaginationFromMeta(initialState.paging, state.paging, action.payload.links)
      };
    }
    case PATCH_VALIDATE_PIP_EPOS_SUBMISSION_REJECTED:
    case PATCH_DECLINE_PIP_EPOS_SUBMISSION_REJECTED:
    case GET_PIP_EPOS_SUBMISSION_REJECTED:
    case GET_PIP_EPOS_SUBMISSION_LIST_REJECTED: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload.errors
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}
